<ng-container>
	<tlk-select
		#favSelect
		[id]="'rx-auto-select-' + id"
		[label]="label + (secondaryLabel ? ' - ' + secondaryLabel : '') + (labelSeparator ?? '')"
		[formControl]="control"
		[required]="isRequired"
		[isDisabled]="isDisabled || isReadOnly"
		[requiredText]="'Validation.RequiredField' | translate"
		[compareWith]="compareWith"
		[getOptionName]="getOptionValue"
		[autoClose]="!isInEditMode"
		[panelClass]="getFavoritePanelClass()"
		[dropdownPositions]="position"
		(openEvent)="onPanelOpen()"
		(closeEvent)="setViewMode(false)"
		(cancelSelectionEvent)="handleCancelSelection($event)"
	>
		<!-- FAV VIEW MODE -->
		<ng-container *ngIf="!isInEditMode">
			<!-- Favorites section (only when favorites enabled) -->
			<ng-container *ngIf="enableFavoriteManagement">
				<tlk-select-option
					*ngIf="shouldShowNoFavorites"
					[value]="null"
					[disabled]="true"
					class="no-favorites"
				>
					<rx-star-checkbox [checked]="false" [disabled]="true">
						{{ 'Favorites.NoFavorites' | translate }}
					</rx-star-checkbox>
				</tlk-select-option>

				<tlk-select-option
					*ngFor="let option of (selectedValues | mapper: getFavoriteOptions.bind(this)); let index = index; trackBy: isTheSame"
					[value]="option"
					[id]="option | mapper: generateOptionId.bind(this)"
					[ngClass]="{ index, option } | mapper: getOptionClassName.bind(this)"
				>
					<rx-star-checkbox [checked]="true" [disabled]="true">
						{{ option.Name | translateOnDemand }}
					</rx-star-checkbox>
				</tlk-select-option>

				<hr class="favorites-divider" />
			</ng-container>

			<!-- All options (non-favorites or simple mode) -->
			<tlk-select-option
				*ngFor="let option of (selectedValues | mapper: getOptions.bind(this) : true); let index = index; trackBy: isTheSame"
				[value]="option"
				[id]="option | mapper: generateOptionId.bind(this)"
				[ngClass]="{ index, option } | mapper: getOptionClassName.bind(this)"
				[style.display]="option.Hidden ? 'none' : null"
			>
				{{ option.Name | translateOnDemand }}
			</tlk-select-option>
		</ng-container>

		<!-- FAV EDIT MODE (only when favorites enabled) -->
		<ng-container *ngIf="isInEditMode && enableFavoriteManagement">
			<div class="favorites-panel">
				<div *ngIf="!(selectedValues | mapper: getFavoriteOptions.bind(this))?.length" class="edit-mode-item no-favorites">
					{{ 'Favorites.NoFavorites' | translate }}
				</div>
				<div *ngFor="let option of (selectedValues | mapper: getFavoriteOptions.bind(this)); trackBy: isTheSame" class="edit-mode-item">
					<rx-star-checkbox
						[checked]="true"
						[id]="option | mapper: generateOptionId.bind(this)"
						(change)="changeSelection(option)"
					>
						{{ option.Name | translateOnDemand }}
					</rx-star-checkbox>
				</div>
				<hr class="favorites-divider" />
			</div>
			<div *ngFor="let option of (selectedValues | mapper: getOptions.bind(this) : false); trackBy: isTheSame" class="edit-mode-item">
				<rx-star-checkbox
					[id]="option | mapper: generateOptionId.bind(this)"
					(change)="changeSelection(option)"
				>
					{{ option.Name | translateOnDemand }}
				</rx-star-checkbox>
			</div>
		</ng-container>

		<!-- FOOTER -->
		<footer class="favorite-footer" [class.view]="!isInEditMode" [class.edit]="isInEditMode">
			<ng-container *ngIf="!isInEditMode">
				<button
					tlkButton
					variant="secondary"
					size="s"
					*ngIf="isCancellable"
					[disabled]="isCancelButtonDisabled"
					(click)="onCancelSelection($event)"
					[id]="'rx-auto-select-' + id + '-cancel-selection'"
				>{{ 'Selector.ClearSelection' | translate }}</button>
				<ng-container *ngIf="enableFavoriteManagement">
					<button tlkButton variant="primary" size="s" class="ml-auto" name="add"
						*ngIf="!(selectedValues | mapper: getFavoriteOptions.bind(this))?.length"
						(click)="switchMode()">{{ 'Favorites.Add' | translate }}</button>
					<button tlkButton variant="primary" size="s" class="ml-auto" name="edit"
						*ngIf="(selectedValues | mapper: getFavoriteOptions.bind(this))?.length"
						(click)="switchMode()">{{ 'Favorites.Edit' | translate }}</button>
				</ng-container>
			</ng-container>
			<ng-container *ngIf="isInEditMode">
				<span>{{ 'Favorites.EditingModeFooter' | translate }}</span>
				<button tlkButton variant="primary" size="s" class="ml-auto" (click)="saveFavorites()">{{ 'Favorites.Done' | translate }}</button>
			</ng-container>
		</footer>
	</tlk-select>
</ng-container>
